<template lang="pug">
.home(@mousemove="getMousePos")
  //- h3 {{currentSceneIndex}}
  //- div(v-html="talkMarkSvg")
  // router-link.btn-game(to="/game") ► 打造我的智慧城市
  // router-link.btn-game.btn-game-sm(to="/game")
    .btn-game-icon
          
  .left-tags
    .tag.orange(to="/explore", @click.prevent="switchPage('/explore')")
      div(v-if="$i18n.locale == 'zh'") 發<br>現<br>台<br>北
      .eng(v-else) Discover<br>Taipei
    .tag.green(to="/prevention", @click.prevent="switchPage('/prevention')")
      div(v-if="$i18n.locale == 'zh'") 科<br>技<br>防<br>疫
      .eng(v-else) Tech Against<br>COVID19

  Tooltip(
    :show="showTooltip",
    :subtitle="selectedItem.title_sub",
    :title="selectedItem.title_main",
    :desc="selectedItem.desc",
    :class="{ show: true }",
    :media="{ link: selectedItem.link, embedVideo: selectedItem.video }",
    @clickMedia="openLink(selectedItem.link)",
    @closeTooltip="showTooltip = false",
    ref="tooltip"
  )
    // @overTooltip="showTooltip = true",
    // @leaveTooltip="showTooltip = false"
  .container-fluid
    .scene-nav
      .left(@click="deltaScene(-1)")
        svg(height="50", width="25")
          polygon(points="24,0 24,50 1,25")
      .right(@click="deltaScene(1)")
        svg(height="50", width="25")
          polygon(points="1,0 1,50 24,25")
    #home-selections.row
      img.logo(src="@/assets/images/logo.png")
      .cats
        .cat(
          v-for="(cat, index) in cats",
          :key="index",
          @click="changeScene(cat.key, index)",
          :class="{ 'scene-selected': cat.key == currentScene }"
        )
          .text-cat {{ $t(`home.scenes.${cat.key}.title`) }}
    .row.w-100.h-100.m-0.p-0.scene-outer-wrapper
      transition(name="fade-scene-2")
        .scene-wrapper(:key="sceneSets[1].name")
          SvgInline(
            :src="sceneSets[1].imgBkg",
            :svg="false",
            :position="getPosition(sceneSets[1])",
            :scale="getScale(sceneSets[1])",
            :style="{ 'z-index': 2 }"
          )
          SvgInline(
            :src="sceneSets[1].imgObj",
            :position="getPosition(sceneSets[1])",
            :scale="getScale(sceneSets[1])",
            :style="{ 'z-index': 2 }",
            :displayExclamation="true",
            @updateSvg="updateHTML"
          )
    .row.w-100.m-0.p-0.side-scene-wrapper
      transition(name="fade-scene-1", mode="out-in")
        SvgInline.side-scene(
          :key="sceneSets[0].name",
          :src="sceneSets[0].src",
          :svg="false",
          :position="{ x: 100, y: -80 + (sceneSets[0].panY || 0) }",
          :scale="sceneSets[0].scale * 1.3"
        )
      transition(name="fade-scene-3", mode="out-in")
        SvgInline.side-scene(
          :key="sceneSets[2].name",
          :src="sceneSets[2].src",
          :svg="false",
          :position="{ x: 125, y: 40 + (sceneSets[2].panY || 0) }",
          :scale="sceneSets[2].scale * 1.3",
          :style="{ 'z-index': 3 }"
        )
</template>

<script>
// @ is an alias to /src
import SvgInline from "@/components/SvgInline.vue";
import Tooltip from "@/components/Tooltip.vue";
import { TweenMax, TimelineMax, Sine, Linear } from "gsap";
import $ from "jquery";
// import * as PIXI from "pixi.js";

export default {
  name: "Home",
  components: {
    SvgInline,
    Tooltip
  },
  data() {
    return {
      showTooltip: false,
      currentSceneIndex: 0,
      currentScene: "gov",
      mousePos: { x: 0, y: 0 },
      cloudPngBase64: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKYAAACVCAYAAADSZoF0AAAACXBIWXMAABcRAAAXEQHKJvM/AAAWGklEQVR4nO1de3AU1Zo/MxMmQIKJuiK1BbI8FkqxCEHKIrM8ygeK5fXyqBKtoi6KYlnIEnnorn/cK1hruVQRhAuFW4AQS5daIMACivIIQuSVq1meQiyBwEKokJAsCUnIJPPI1ol9YufL+fqc7ume9GTOr6rrTPd09zkz85vf+b7zfee0p7W1lSgouA1e9YsouBGKmAquhCKmgiuhiKngSihiKrgSipgKroQipoIroYip4EqkqJ/FHDwejydedbUmcfRDKaaCK6FCkhriqYROoLupq1JMBVciqRTTZlV0UmFt+1ESVUmVYiq4Et1aMS0qJLzG7D3MnG/2y4fnm/7xEkVBlWIquBLdSjFNKKQHeY2dI7NvJ0TKaPSjtUqc8/vJLiWAUkwFV0IRU8GVSOiu3ELXzTsfvod14U527bJdt9F5onMSqmtXiqngSiSkYkoopUjleH9Ib2Vl5YTU1NSM1NTUrGg06vH7/SM9Hk8G+U1JPNFotC4UCp1jF1RWVh6j5a5du84vXrz4bgwfSaR2UXAc7hudk5AKmrTErK2tndCzZ8+slJSUiV6vd6DH4xkZa7tCodDxcDh8PRgMnisrKzs2ZsyY85KXKmICJAQx7SBiRUVFVkZGxkS/3/9Hn8833oFmcnHv3r19dXV1xw8cOPDd66+/fgOcg5EEkgru8wgrOhcjuTRR40nSbk3M2traUenp6a95vd4pHo/nEedaKIdIJFJeVVW1TkdSRUwEriamBUJ6SkpKMh999NGpvXr1+osbyIihqamp+OLFixvHjBmz34A8cB8rZc4R1UGQ81A4SdRuQ8zS0tLMoUOHvpuSkpJLCMmIQ/NsQTgcvllWVrZi+PDhBYqYv8N1xBSQsVOXnaiEhAgGg78UFhZ+/NJLL/3NgFwRZN/oHNFxrMvvUoImNDGbmpom9uzZcxMhZGB8Wuc8ampqds6dO/ffCgoK7ipiugBmCFlSUnL/qFGjPvT5fPNd0XibEYlEGgoLC/88efLkg9qdI4KSd04Y7IsIipkPehiS1U6CJhwxGxsbs3r16pVvx7ij21FeXv7VgAEDlilidgHMKCUd/snIyDiUyLakWdTW1p6aPn36osOHD9dzyBbW3S4sKDHiQsLKDElJdfOxEDVhYuXNzc1Tko2UFJmZmaO//vrr9U899VQfFzQnboi7YpoYAiJAKUucbZm7UV9ff3ny5MnzTpw40aBTu5Cu0fBYCByH75vt6onJEOnvF1kgmesVk9qUmlImNfr06TN03759awOBQHoyfA9xU0wrYcUffvjhgXHjxpW4OYITb9TV1ZVNmjRpwU8//dQAFBMqZQtyHFNUGQcLG/CH78fsHLmamNFo9HuPxzPB2ZYlHsLhcOPZs2e3r1279pv8/Pxb2gdQxDQDCUJCc6JtPxgM5qampuY52rhuAKqg33///a5PPvmkqKSkRK+izVoJiSoiLDbcRCyEPS177a4k5o0bNwb279+/JNk88FhAVfTMmTM75s+fv6W4uLhBERO7sUWlpGU4HC7w+XwvOdKwbg5K0KKiov989tlnt2mftBmUkKAYUXnExDx52TS9DjAipuu88pqamgmKlNaRkpKS9swzz7xdV1e3/oMPPhiaqJ/DdsU0UEosy9zHjpeWlg4cPnz4QeWF24NQKHRv7969/zFt2rSDHOUUKanRWCkWPZLt4juAp5yuIOaVK1cGDhgwILdHjx5/Unal/Th//vyukSNH/lXbVcSEb4GSzjL8hwcffHCJz+f7k62NUOiEq1ev7h88ePCypCOmCUK2lc3NzUv8fv98pZDxw6+//npo+PDh/65VKEtQo0F8bAzUEkGJjqRxd35qa2uzWltbL/v9/j8rUsYXw4YNe2b37t3PJ0JbnVTMTkoZCoVyU1JSVthSoYJl5ObmLlyzZk2pdj1TyiDYhwpKJLp725QzbsSMRCKbvF7vLFsqU4gJjY2Nt9PT05ld70pixtyVezTw3tKm094fjUZPKVK6B2lpaQ8VFRW9QV8SQnojWy9t66nbUsHWA2w+sHm1zSPYOsFRG5POYBw9evShZJgGkWjIycn5w+OPP57m1mZb7soNvPB2skej0Z0ej+ePVhun4CwKCwt3TZo06b+0Spq0MgjKJl0jRJ68yGsXTeNoh2OKGYlEPlWkdDfGjh07zq0NNEVMjw68t3VjlFO8Xm+uba1MEty4cYOcPHmS3L0by4qG8khPT/+75cuXj9dsTbjxbE9mb2K2ZgrYmM0JbU0j27MNtj/klEZz/H7/Jme+yu4HSsYVK1aQffv20Xk97Z+vf//+ZMaMGeStt94i9913n2OfOxAIDCeEnHLbF2vKxkTsyg7DQuFw+L+7Q3bQhQsX2jZKnBEjRrRtAwYMsLWObdu2kYULFxqe06dPH7Jjx462+p3A9evXLw0cOPCvpLNNeQ/s845BexTantDWZPuYrdn+2lZiaku2JPTEMUoWqmDl5eWd3svJySEfffSRLSSRISWD0+T0eDz/nJDEFCT9MjuV3uuyE+sIUdWiPyRVMGp/MQWbPHmyrd3cggULSEFBgfC8lStXtnWzVkE/z6RJkzp03SI89thj5ODBg5brNMKgQYOWXLt27Y52CiTmPd2l7L1GsI8RFfPWjaYIt722zStvaWmZZTcpKQnfeOMN6j2STz/9lOzfv7/NOfj888/b1ObJJ58kGzZssKUuWVJS0LqpTWgVtP1mSElx8eLFmOo0wosvvvj3jtw4BsRCzI5eVErKa3Y2jKkKJSMG+uMuXbq0jVSxgJJdlpQMS5YssVyjVYI5RcxwOJyq87x7GWzMC2feuV/bZL1yzBvXo+2YLYpJFyWwe5otVUqenccDJVUsymnlWto2al5Ygezn4tWZLDAkpkEcnOgZn5qa+rqd3xf9wWnXZQbUYbE6/nfixIm4Xuc2nD59ukmngrwYOdzgOCamnJhiegH3OqmnLYrp8/lsjfBYUTDarVvt6szaewzdRcF+/PHHOhc0owPMErMTs69cuTLIbqfHrFoyJIqCPf+8tVxdq9cZoby8/DZHAVMNojxGCgmVEov8MDhnY/br12+inV9ULLCqYHSc0ApodMYK6DBXPK8zwpUrV27bflMbEItiMvsy4dcWsvqDBwIBS9fRMVA6WG8GixYtsj3yRLF79+5rmur5JTaYf4nZlCLbUhgrj1kx6ePuYv52AKwqmNkfm+GVV14xfQ2LZVvFpk2b2gbNZfDyyy+TxYsXW64LQ1NTU8vKlSvLbL+xDeASk+ONo7aAE6uxxburo4SeM2eOqWtWrVplqS4GGrGiYUajeukflI7TxloXhm+//fYyxz5kG89+xBQyVtuyk2JyQ5ISE8sII3Vra2sLsRl0cJ1Ge8yAkmv79u0xNSReIUkI+nnpiAK1kWnYlX4W2m3bHXKFyM7OLjhz5kyNdpjFt2GYsUF3GQtF1oOyAZQwnMnuxerAYueEhStdSUxiIcmBxpHtsMHilcTR1Th48ODl55577ign8SLhiemjj1bOyMhwJrNAkpzU1qP2mt1kYSlvtKRODq3HCeejK3Dv3r3QkCFDdty6dauFQ0yWgMFI1ahrIiQiRlB2DbsHTO6ASR2JRUzigkTa7oi8vLxT77///s/aR0toYrantumP0cWwBg8e/Gu8fjsacmQ2mII1nDx5sjwQCBzVdafMFJPpyiEh2T6LBTeC41hXDueld3qQVkzEJL/ZmM1EISFw9erV2kAgcEjrwl1NTLNzfjoRUyExQEmZk5NzpLKy0g5nVbRadMyImVzRaPS8041UiA1lZWV1GilDifJVdiCmIM2Ni3A4fN3xVipYxrlz524HAgGmlK0SG0NU24yuiQLHBTsPA/p+zIoZCoXOKdq4E+vXry/NysoqSiSlZBARUxg6qqysPOZoCxVM4+zZs9VPP/30obfffvsiR93YFrFhg/fEVBa+L0TMCx4MGTLkqFueeZ7soIT8+OOPS7dv335b9IwdtyMWYrYPure0tOz1+/0vJjsxugI0irNnz57r69evv3b48OE6zrN2RI/ig+upY0/t5R0T3ROuh0kk9+1ZIqa2tnZv3759FTHjBKqMxcXF1YWFhbe3b99erdXarbqtDgPsEqFIn+499pqmQdFhoxsej0fFBh3AsWPHKo4fP169b9++6iNHjvBUkXDUCVMx7BF+cCUOoyQOmLQBj8N7YCt0oA9StW1RrTt37qx74IEH3rfrfgq/jT9OmTLlx59//rkx2b4O2xY8WLZs2brW1tb4rJ+XBKCkDAQCxzRSMu8WetI8jzgMtpC2tSBbs2DTX8fOZfshsLF2sTZg3joDbxyz7VgsXXkKKP01NTX/olQzdlCHZvDgwQd14UOZh4dizg50WGBXDrOKYDesV2vYdcMS5mFiKw/DNtm6dlEntlPVjEaj1iZpK7RjzZo1v2ikxMYJoTKFOeoFFRIqY1CwNWmb/jx4D5Fywk0mYtQG25wfbYYdOXXq1JTs7OzPFc2sgTo648eP/5t2Mfa4Zd4qabJKCR+0jykmb7U3kULC/EtYh2g5wvbPajsx6YT4hoaGjWlpaQnxBC43QbMrj1ZWVrIfEiMkz5u1SkgzxITdu+x6mV23DKEeCxYsWBgMBn9x4t7dFTpSJlxc2wnYoZjtzo9W0mVFSH5+/uhZs2Zt9nq91iaJJxE0UhYZODtQYXgJttjqvZizA5USc354iolNmYBKiTk7RpEh5xSTYvbs2aVffvnlzEgk0iBxetJiy5YtVzRSKqXUIRbFZKTuAcpUraRL2ZHVq1ePfuedd/J9Pl+6Ux8iEUHzJGnCRUFBwW0DpwZTSl4cG1NITCkxxcSUk0jYkphNiTk7PMW0N/KDITc3l9qasxU5fxufPHLkSMUXX3xxTSOkAgLHiUk0ct69e/edd9999y/p6en/2F1/DEq8S5cudVhrkiZb1NbWhkpKSuq0dDQim5OYzBB15QxeUBKO8wO78p5a2ZuVEydO7JOfn/+vgwYN6lZDSVVVVffmzZt3SpfpQ5CoDNwXdeHYEBCc4Uhi6MJFXToreddAJwc+pQKL8GDjs+2IKzG1Mn3z5s3jpk6dOr937959kfoSBiymzXFeFDHtImb7Qbl55Rgx2wfatbKXVqbpy+zs7H6fffbZ1CeeeGJajx49GGkdBZ3CmpaW5u/bt68t9dGue+zYsYfOnz+vH1LhxbGxWLdoGEg0WG70kHtZZ0dEWP26ASIiyhJS+ED9Lpsbfvr06cacnJzN2dnZ84qKigrq6+trJC4zDUqeDRs2XBg5cuRemhjx8MMP7/3uu+/+1457L1q06H8AKRVsgtm1i/REZq87ZRlpJVRMrnLSxdrY/qpVq56YMGHC2BEjRozy+/3sfEu4fft241dffVW6fPnyslu3brF/brvyV1VV/eGhhx6y/CD5rVu3Xnr11VfP6g7BLxImKRCDrlq2y8a6a2KgkLKKiJV6EwXGvEUD6FjoEVVKBlcRUyvbhpTee++9YePGjXs8KytrSGZm5oOZmZmZ2IdguHDhwq2Kior6Xbt2la9du/YGxzZuJ+bWrVuzZ8yYMUx0Tx6oXTlkyBC4mJgipo3ENDtcxLsRZsiazQfsYKvm5eWdz8vLY8swt9mEjzzyyP0vvPBCv0gk0kb+cDjsr66uDn7zzTd14B6sZHYwtJG99fX1eqNeGtQ0mDZt2lEQDuR9fp7zI7IlsbAiJCL87ogNBMTq0BMTS8YQhRqhc4MSslVTyriMY9qF69evB9etW3dN5/EzVfabraKwsLDyzTffNN2y2bNnHzt37lzSTXWIN2SJyRju4RxjwMJN2CQo5sVDxdS3iTcawGsXq4PdE96rU1fu9XpNx6Y3btx4btu2bTcFpxnlSrJjmPcKu0ZMzYw8ZpFiYveCvw9UbV57sd+c9x0QTClbOfakWrFNEsXFxTfmzJmjlsOJE7iKyRgsWGAL2g8esA89YWbvwX+mDykJJ4kE1s3+qawrZ3Viitluc/p8PmnFrK6ubpg+ffoRrc1Ym4zsKll7Gybzyo5NGr0H74UpJKbi+kQRWacGc3Kk574rxRSAPgtn5syZhRUVFY48BEGBDzu8cvhvwIZE2D+SqRb752JDOkb1YwqE2ZhQlb0pKSlSKyHn5eUdPXDgwE2OUmIqzpvHgnnfIm9bpJRGimlWITFP28hWlvW+pW1LBqWYBtizZ8/ZDz/8UE0R6QLEopgecEzW1mwB+yLPm1cHZqvBpGVsPNNXWlp6y6A+cvPmzaopU6Yc4AQXRAvb8hTT7HQHs/YiMVBfkUKKFsgyWobGki1ppJQMSauYxcXFtXfu3OE+pzsYDDaPHTt2S/xbpcBgqJgC7xxbWg7agYz87J8pUiBeVg5mo7GSeeVQMWEGVAfvfPXq1buWLFnymr7y5ubm4MyZMzeVl5f/H7hGxgYmHFXntRuzJUVjjzLhQmxaA+Ztizxto9AqPB6zUjIkVOTHbixduvRCVVXVhrlz5/5T7969ezU2NgaXLl16eOfOnRVgfpNCnMFN4oAQjGd2ikODEsvbhPmbMPlD/xqGHuE+ZluyfZhwwptU18kORY6LlJ5nY9ptW/KSOEQKicW1sfg2Tx1ttyUxKK9cwZWQ6spN2prQ/mDXwGwc7D68rBzMC5e1LTFbkxhEnkSKCf/U2MgBr912ZfzwMn9kl6MWrYskM2bNRSxKyaAUU8GVsMP5wf4d6EQjwflGigmziJhKwEiPSCl5S93AEhsDxWxNqDQyixGIvG/ZuTVEwna0NWrT4UQHHluiFFPBlVDEVHAlTHXlesnmOEIiJ0gEowRb1k7ZZA0seQOWhNO9i66VdX6MQpKidDazCReEk3QhOwxkOTXNiS6cQSmmgith2fkxGEISKSf2DzWaxIXNJoRODZq0gRznvSdSTuj0wGQWGEYlBqFUqJBmZyHqnR/ZRQVc5eRgUIqp4ErEPFxkQTlFE8tkFBNTQswOxBRU5l6yNibWZmKQhIINA8kOlvNS0mwZBoqnOvKgFFPBlYhHdhH2z8P+yTwVYGoFFVNUyoQTZZM4RDYm/BxmnighevKtKDWNGNjuprztrlZKBqWYCq6EVNqbFRikymFKw1sfCZ4rSrHD1ozH7kMk7FLZJA4G3ugCNjEPU1LZ5F2eYsJ9V9uSGJRiKrgSjikmgyDJmBgoKDFQQlEJ/3CY0hIDJRQlCGN/aiNbGUtBw6bMyi5SRRJdISGUYiq4Eo4rJoOEcrafirwmBkopet/IxsTsV5EXLlJMo2UIMdtRZFOa9rQTRSEhlGIquBJxU0wIEwpKBHYo732RkuqB2Y6iEQHZpWIIR+GgQmL5AkmnlAxKMRVciS5TTAiTCsqAKSN2noxywn2RvQphNIlLNjfSdHw70RUSQimmgivhGsXkwaKKEhNKSiQU0Yy9qgdvqRurJb+CbqaSeijFVHAlXK2YGGJQUgajsVJ4XFYhZSDyrrtV9CYWKMVUcCUSUjFFiJOHbwaiRSGSXiEhlGIquBKKmAquRLfsyjHY1MWLjjMYfbEJNc2hK6AUU8GVSCrF5MGGoSfbkMwKCaEUU8F9IIT8P+o2Y+rzLRZuAAAAAElFTkSuQmCC`,
      talkMarkSvg: `
        <defs><style>.ad56ba03-60bc-4bf3-ac4b-91af124b03e7{isolation:isolate;}.aa668e81-b1b2-41c9-af5d-4d35c7c0ad47{opacity:0.7;mix-blend-mode:multiply;}.a8dcad5a-68e8-4ed7-8f39-6c9e0031d072{fill:#fff;}.f144a559-f832-4fb0-af6d-74e03bb7bde9{fill:#1a1a1a;}</style></defs><g class="ad56ba03-60bc-4bf3-ac4b-91af124b03e7"><g id="f4a8d7af-46a0-486b-a692-3027805336ba" data-name="圖層 1"><g id="a0c2b92d-4083-4b07-90be-71247c249d08" data-name="cloud_sign"><g id="e40f62b1-4738-45aa-9197-62bca2832dd5" data-name="cloud"><image class="aa668e81-b1b2-41c9-af5d-4d35c7c0ad47" width="85" height="74" transform="translate(-1 2)" xlink:href="data:image/png;base64,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"/><path class="a8dcad5a-68e8-4ed7-8f39-6c9e0031d072" d="M54,18.17a5,5,0,0,1-2.2-1.12C47.53,12.36,42,10.78,35.9,10.43a18.08,18.08,0,0,0-4.41.34c-5.88,1-11.08,3.23-14.07,8.87a3,3,0,0,1-1.68,1.19A14.3,14.3,0,0,0,8.15,38.39a14.57,14.57,0,0,0,16.68,9.49c1.56-.32,3.41-2,4.42-1.05s.49,3.15.65,4.81c.08.86.27,1.68,1.2,2,1.09.38,1.66-.38,2.21-1.1,1.62-2.07,3.26-4.12,4.82-6.24a2.74,2.74,0,0,1,2.55-1.26,8.6,8.6,0,0,0,7.88-4.3A3.44,3.44,0,0,1,51.27,39c4.41-.81,7.93-3,9.7-7.26C63.18,26.42,60.08,20.52,54,18.17Z"/></g><g id="b4864f4c-fc89-4ea9-9820-dd06d5f4c4df" data-name="dot"><circle class="f144a559-f832-4fb0-af6d-74e03bb7bde9" cx="20.98" cy="30.71" r="3.5"/></g><g id="a39b4cd1-acc7-4f06-8e86-7ac6d7d9258b" data-name="dot"><circle class="f144a559-f832-4fb0-af6d-74e03bb7bde9" cx="34.44" cy="29.87" r="3.5"/></g><g id="b8affa85-4ba6-4191-ac37-1fea59997537" data-name="dot"><circle class="f144a559-f832-4fb0-af6d-74e03bb7bde9" cx="47.9" cy="29.04" r="3.5"/></g></g></g></g>
      `,
      cats: [
        {
          name: "智慧政府",
          key: "gov",
          src: "/scenes/gov.png",
          imgObj: `/scenes/gov_obj.svg`,
          imgBkg: `/scenes/gov_bkg.png`,
          scale: 0.78,
          panX: -10,
          panY: 5,
          animaions: require("@/assets/animations/gov.js"),
          staticPos: {
            x: 500,
            y: 0
          },
          mobilePos: {
            x: 0,
            y: 0,
            panX: 0,
            panY: 0,
            scale: 0.78
          }
        },
        {
          name: "智慧交通",
          key: "traffic",
          src: "/scenes/traffic.png",
          imgObj: `/scenes/traffic_obj.svg`,
          imgBkg: `/scenes/traffic_bkg.png`,
          scale: 0.85,
          panX: -5,
          panY: -0,
          animaions: require("@/assets/animations/traffic.js"),
          staticPos: {
            x: 0,
            y: 0
          },
          mobilePos: {
            x: 0,
            y: 0,
            panX: 0,
            panY: -18,
            scale: 0.85
          }
        },
        {
          name: "智慧教育",
          key: "edu",
          src: "/scenes/edu.png",
          imgObj: `/scenes/edu_obj.svg`,
          imgBkg: `/scenes/edu_bkg.png`,
          scale: 0.8,
          panX: -5,
          panY: 10,
          animaions: require("@/assets/animations/edu.js"),
          staticPos: {
            x: -500,
            y: -500
          },
          mobilePos: {
            x: 0,
            y: 0,
            panX: 0,
            panY: 0,
            scale: 0.85
          }
        },
        {
          name: "智慧健康",
          key: "health",
          src: "/scenes/health.png",
          imgObj: `/scenes/health_obj.svg`,
          imgBkg: `/scenes/health_bkg.png`,
          panX: -5,
          panY: 5,
          scale: 1.0,
          animaions: require("@/assets/animations/health.js"),
          staticPos: {
            x: 0,
            y: 0
          },
          mobilePos: {
            x: 0,
            y: 0,
            panX: 5,
            panY: 5,
            scale: 1
          }
        },
        {
          name: "智慧環境",
          key: "env",
          src: "/scenes/env.png",
          imgObj: `/scenes/env_obj.svg`,
          imgBkg: `/scenes/env_bkg.png`,
          scale: 0.75,
          panX: -15,
          panY: 10,
          animaions: require("@/assets/animations/env.js"),
          staticPos: {
            x: 0,
            y: 0
          },
          mobilePos: {
            x: 0,
            y: 0,
            panX: 0,
            panY: -10,
            scale: 0.75
          }
        },
        {
          name: "智慧安防",
          key: "security",
          src: "/scenes/security.png",
          imgObj: `/scenes/security_obj.svg`,
          imgBkg: `/scenes/security_bkg.png`,
          scale: 0.9,
          panX: -10,
          panY: 25,
          animaions: require("@/assets/animations/security.js"),
          staticPos: {
            x: 0,
            y: 0
          },
          mobilePos: {
            x: 0,
            y: 0,
            panX: 10,
            panY: -5,
            scale: 0.95
          }
        },
        {
          name: "智慧建築",
          key: "architecture",
          src: "/scenes/architecture.png",
          imgObj: `/scenes/architecture_obj.svg`,
          imgBkg: `/scenes/architecture_bkg.png`,
          scale: 0.92,
          panX: -2,
          panY: 15,
          animaions: require("@/assets/animations/architecture.js"),
          staticPos: {
            x: 0,
            y: 0
          },
          mobilePos: {
            x: 0,
            y: 0,
            panX: 10,
            panY: 15,
            scale: 0.92
          }
        },
        {
          name: "智慧經濟",
          key: "eco",
          src: "/scenes/eco.png",
          imgObj: `/scenes/eco_obj.svg`,
          imgBkg: `/scenes/eco_bkg.png`,
          scale: 0.88,
          panX: -10,
          panY: 10,
          animaions: require("@/assets/animations/eco.js"),
          staticPos: {
            x: 50,
            y: 50
          },
          mobilePos: {
            x: 0,
            y: 0,
            panX: 5,
            panY: -10,
            scale: 0.9
          }
        }
      ],
      selectedItem: {
        title_zh: "體溫感測系統",
        title_en: "A temperature sensing system",
        desc:
          'A temperature sensing system was installed at the school gate to verify the field, and the thermal imaging technology was used to externally connect to the "radio frequency identification" (RFID). The students measured the body temperature after using the digital student ID card to identify the body temperature. If the temperature was too high, the school performed Report to maintain a healthy learning environment.',
        link: ""
      }
    };
  },
  created() {
    let scene = this.$route.query.scene;
    let itemIndex = this.$route.query.itemIndex;
    if (scene && itemIndex) {
      let sceneIndex = 0;
      let sceneIsValid = false;
      // break forEach if found

      this.cats.find(s => {
        if (s.key === scene) {
          sceneIndex = this.cats.indexOf(s);
          sceneIsValid = true;
          return true;
        }
      });

      if (sceneIsValid) {
        this.changeScene(scene, sceneIndex);
        let items = this.$t(`home.scenes.${scene}.items`);
        let item = items[`${scene}_${itemIndex}`];
        setTimeout(() => {
          let area = document.querySelectorAll(`[data-name='area']`)[
            itemIndex - 1
          ];
          let els = document.querySelectorAll(`[data-name='!']>g`);
          // console.log(els);
          let itemEl = els[itemIndex - 1];
          // let itemCloud = itemEl.querySelector(`[data-name="cloud"]>path`)
          let itemCloud = itemEl.querySelector(`[data-name="cloud_sign"]`);

          TweenMax.set(itemCloud, {
            transformOrigin: "50% 50% 0%",
            y: 50
          });
          let scaleAni = new TimelineMax();

          scaleAni
            .to(itemCloud, 1, {
              scale: 2,
              y: 100
            })
            .repeat(-1)
            .yoyo(1);
          let itemPos = itemEl.getBoundingClientRect();
          TweenMax.to(document.querySelector(".home"), 1.5, {scrollTo:{y:itemPos.y - 100}});
          this.$refs.tooltip.setPosition({ x: itemPos.x, y: itemPos.y + 100 });
          this.selectedItem = item;
          this.showTooltip = true;

          $(document)
            .add("svg")
            .add("g")
            .add("rect")
            .on("click", () => {
              scaleAni.kill();
              TweenMax.set(itemCloud, {
                scale: 1,
                x: 0,
                y:0
              });
            });
        }, 1500);
      } else {
        this.changeScene("gov", 0);
      }
    }
  },
  computed: {
    sceneSets() {
      let stIndex =
        (this.currentSceneIndex % this.cats.length) - 1 + this.cats.length;
      return this.cats
        .concat(this.cats)
        .concat(this.cats)
        .slice(stIndex, stIndex + 3);
    }
  },
  methods: {
    switchPage(path = "/") {
      this.$store.commit("setPageDelay", 300);
      this.$store.dispatch("triggerLoading", 1500);
      setTimeout(() => {
        this.$router.push(path).catch(() => {});
      }, 300);
    },
    updateHTML() {
      // console.log('parent update')
      // console.log('svg stuff:')
      // console.log($('.svg_inline')[0].innerHTML)
      this.bindIcons(this.sceneSets[1].key);
      this.triggerAnimation(this.sceneSets[1]);
    },
    sceneEntered() {
      // this.triggerAnimation(this.sceneSets[1]);
      // this.bindIcons(this.sceneSets[1].key);
    },
    getMousePos({ x, y }) {
      this.mousePos.x = x;
      this.mousePos.y = y;
    },
    getScale(cat) {
      if (window.innerWidth < 768) {
        return cat.mobilePos.scale * 1.2;
      }
      return cat.scale * 1.5;
    },
    getPosition(cat) {
      if (window.innerWidth < 768) {
        return {
          x: 33 + (cat.mobilePos.panX || 0),
          y: 10 + (cat.mobilePos.panY || 0)
        };
      }
      return {
        x: 33 + (cat.panX || 0),
        y: 10 + (cat.panY || 0)
      };
    },
    getStaticStyle(cat) {
      let left =
        (cat.staticPos.x || 0) - (this.mousePos.x / window.innerWidth) * 500;
      let top =
        (cat.staticPos.y || 0) - (this.mousePos.y / window.innerHeight) * 500;
      return {
        position: "absolute",
        top: 0,
        left: 0,
        transform: `scale(0.3) translate(${left}px,${top}px)`
      };
    },
    triggerAnimation(scene) {
      this.$store.dispatch("loadSvgData", scene.imgObj).then(() => {
        setTimeout(() => {
          scene.animaions && scene.animaions.play();
          TweenMax.set("[data-name='!']", {
            transformOrigin: "50% 50%"
            // ease: Linear.easeNone
          });
          TweenMax.to(
            "[data-name='!']",
            0.4,
            {
              y: -10,
              // scale: 1.04,
              ease: Sine.easeInOut
            },
            0.1
          )
            .repeat(-1)
            .yoyo(true);
          console.log("Trigger", scene);
        }, 1);
        //關閉載入頁面
        setTimeout(() => {
          this.$store.commit("setLoading", false);
          console.log("close loading");
        }, 100);
      });
    },
    changeScene(sceneKey, index) {
      this.currentSceneIndex = index;
      this.currentScene = this.cats.find(c => c.key === sceneKey).key;
    },
    deltaScene(value) {
      this.currentSceneIndex += value + this.cats.length;
      this.currentSceneIndex = this.currentSceneIndex % this.cats.length;
      this.currentScene = this.cats[this.currentSceneIndex].key;
    },
    bindIcons(sceneKey) {
      let svg = document.querySelector(`#svg_${sceneKey}_obj`);
      let icons = svg.querySelector(`[data-name='!']`).querySelectorAll(`rect`);
      // .querySelectorAll(`[data-name='area']`);
      let marksContainer = svg.querySelector(`g[data-name='!']`);
      let marks = svg.querySelectorAll(`[data-name='!'] rect`);

      // setTimeout(()=>{
      // Array.from(marks).forEach(el=>{
      //   var circleElement = document.createElementNS('http://www.w3.org/2000/svg', `image`);
      //   circleElement.setAttributeNS('http://www.w3.org/2000/svg',"xlink:href",`data:image/png;base64,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`)
      //   circleElement.setAttributeNS('http://www.w3.org/2000/svg',"x","0")
      //   circleElement.setAttributeNS('http://www.w3.org/2000/svg',"y","0")
      //   circleElement.setAttributeNS('http://www.w3.org/2000/svg',"width","200")
      //   circleElement.setAttributeNS('http://www.w3.org/2000/svg',"height","200")

      //   // href="firefox.jpg" x="0" y="0" height="50px" width="50px"
      //   // circleElement.setAttributeNS('http://www.w3.org/2000/svg',"y","100")
      //   // svg.appendChild(circleElement);
      //   marksContainer.appendChild(circleElement)
      //   console.log(circleElement)
      // })

      // },1000)

      TweenMax.set(`[data-name='!'] [data-name='area']`, {
        css: {
          cursor: "pointer",
          "stroke-width": "100"
          // stroke: "black",
          // "stroke-opacity": 0,
        }
      });
      TweenMax.set(`[data-name='area'], #area`, {
        css: {
          fill: "transparent",
          stroke: "none"
        }
      });

      for (let index = 0; index < icons.length; index += 1) {
        let item = icons[index];
        item.addEventListener("click", e => {
          e.stopPropagation();
          if (this.showTooltip) {
            let tl = new TimelineMax();
            let tooltip = ".st-tooltip";
            TweenMax.set(tooltip, {
              ease: Sine.easeIn
            });
            tl.to(tooltip, 0.1, {
              scale: 1.2
            }).to(tooltip, 0.1, {
              scale: 1
            });
          }
          this.$refs.tooltip.setPosition({ x: e.pageX, y: e.pageY });
          this.showTooltip = true;
          this.selectedItem = this.$t(
            `home.scenes.${sceneKey}.items.${sceneKey}_${index + 1}`
          );
        });
      }
    },
    resetTootipLang() {
      let items = this.$t(`home.scenes.${this.currentScene}.items`);
      for (const item in items) {
        if (items[item].title_main == this.selectedItem.title_sub) {
          this.selectedItem = items[item];
          return;
        }
      }
    },
    openLink(link) {
      window.open(link);
    }
  },
  watch: {
    // sceneSets() {
    //   setTimeout(() => {
    //     this.triggerAnimation(this.sceneSets[1]);
    //     this.bindIcons(this.sceneSets[1].key);
    //   }, 1500);
    // }
  },
  mounted() {
    $(".icon-lang").click(this.resetTootipLang);
    setTimeout(() => {
      document.querySelector(".home").onscroll = e => {
        if (e.target.scrollTop > 20) {
          $(".icon-home").addClass("hideIcon");
        } else {
          $(".icon-home").removeClass("hideIcon");
        }
      };
    }, 1000);

    $(".home")
      .on("click", () => {
        this.showTooltip = false;
      })
      .children(".st-tooltip")
      .click(function (e) {
        return false;
      });
  },
  beforeDestroy() {
    $(".icon-lang").off("click", this.resetTootipLang);
  }
};
</script>

<style scoped lang="sass">
@import "@/assets/css/mixins.scss"
$easeInOutCubic: cubic-bezier(0.65, 0, 0.35, 1)

.fade-scene-1-enter-active,.fade-scene-1-enter-active
  transition: opacity 1.5s 1.5s,transform 1.5s 1.5s

// .fade-scene-2-enter-active,.fade-scene-2-leave-active
//   transition-delay: 0s

.fade-scene-3-enter-active,.fade-scene-3-leave-active
  transition: opacity 2s 4s,transform 2s 4s

.fade-scene-1-enter-active, .fade-scene-1-leave-active,.fade-scene-2-enter-active,.fade-scene-2-leave-active,.fade-scene-3-enter-active, .fade-scene-3-leave-active
  transform: translate(0px,0px)
  transition: opacity 1.2s,transform 1.2s

.fade-scene-2-enter-active,.fade-scene-2-leave-active
  transition: opacity 0.8s,transform 0.8s

.fade-scene-2-leave-active
  transition-delay: 0s
.fade-scene-2-enter-active
  transition-delay: 1s

.fade-scene-1-enter, .fade-scene-1-leave-to,.fade-scene-2-enter, .fade-scene-2-leave-to,.fade-scene-3-enter, .fade-scene-3-leave-to
  opacity: 0

.fade-scene-1-enter,.fade-scene-2-enter,.fade-scene-3-enter
  transform: translate(0,50px)

.fade-scene-1-leave-to,.fade-scene-2-leave-to,.fade-scene-3-leave-to
  transform: translate(0,-50px)

.left-tags
  position: fixed
  right: 0
  top: 170px
  z-index: 20
  @include for_breakpoint(mobile)
    display: none
  .tag
    cursor: pointer
    display: block
    background-color: #333
    margin-bottom: 20px
    padding: 20px
    padding-right: 60px
    color: white
    box-shadow: 0px 0px 20px -5px rgba(black,0.5)
    font-weight: bold
    font-size: 1.2rem
    line-height: 1.22
    transition: 0.5s
    transform: translate(40px,0px)
    text-shadow: 0px 0px 10px rgba(black,0.7)
    .eng
      transform: rotate(90deg)
      padding: 25px 0px
      margin: 0px -25px
      margin-left: -30px
    &.orange
      background-color: #F47457
      background-image: url(/img/explore_beimen.png)
      background-size: auto 100%
      background-position: 10% 20%

    &.green
      background-color: #63D1D0
      background-image: url(/img/prevent-2.png)
      background-size: cover
      background-position: 0% 50%
    &:hover
      transform: translate(0px,0px)
      &.orange
        background-color: darken(#F47457,5)
        background-position: -5% 50%
      &.green
        background-color: darken(#63D1D0,5)
        background-position: 5% 50%

        text-decoration: none

.scene-wrapper
  position: relative
  // .svg_inline
  //   height: 100%

  @include for_breakpoint(mobile)
    top: 30vh
    width: 140vmin
    height: 0px
    transform: translate(-25vmin) scale(1.45)

.side-scene-wrapper
  position: absolute
  height: 110%
  top: 0
  left: 0

.home
  position: relative
  overflow-x: hidden
  overflow-y: auto
  height: 100vh
  width: 100vw
  min-height: $size__site_min_height
  background-image: url(/img/index_grid.svg)

  .btn-game
    position: fixed
    border-radius: 100px
    background-color: white
    // border: solid 4px white
    font-weight: bold
    letter-spacing: 1px
    color: black
    padding: 8px 15px
    right: 100px
    bottom: 50px
    z-index: 50
    box-shadow: 0px 0px 20px rgba(black,0.3)
    &:hover
      background-color: black
      color: white
      text-decoration: none
    &.btn-game-sm
      display: none
    @include for_breakpoint(mobile)
      display: none
      right: 25px
      bottom: 125px
      width: 60px
      height: 60px
      &:hover
        background-color: white
        box-shadow: 0 0 27px 1.5px rgba(0,0,0,.4)
      &.btn-game-sm
        display: initial
        .btn-game-icon
          background-image: url('/img/dice-d8.svg')
          background-repeat: no-repeat
          background-position: center
          width: 100%
          height: 100%

      
      
      
  .map-container
    // background-color: black
    background-color: transparent
    width: 100vw
    height: 100vh
    position: fixed
    left: 0
    top: 0

    img
      position: absolute
      transform-origin: 50% 50%

      // width: 

      // transform: scale(0.5)
      // left: 0
      // top: 0
  .sideImage
    width: 50%

  .container-fluid
    position: relative
    height: 100%
    padding: 0
    margin: 0
  // .scene-outer-wrapper
    // overflow: hidden
  .scene-nav
    display: none
    @include for_breakpoint(mobile)
      display: block
    svg
      // width: 30px
    polygon
      stroke: black
      fill: transparent
      stroke-width: 2
      &:hover
        fill: black
    .left,.right
      position: fixed
      top: 50%
      cursor: pointer
      z-index: 5
      &:active
        transform: scale(1.2)

    @include for_breakpoint(mobile)
      .left,.right
        transform: scale(0.8)

    .left
      left: 3vw
    .right
      right: 3vw
  #home-selections
    position: absolute
    left: 0
    top: 0
    // left: 0
    // bottom: 0
    width: 100vw
    height: 100%
    margin: 0

  #home-selections > *
    z-index: 5
  .svg_inline
    position: absolute
    left: 0
    top: 0
    width: 80vw
    // max-width: 1000px
    max-width: 800px
    z-index: 1
  img.logo
    position: absolute
    left: 0px
    top: 120px
    width: 38vmin
    max-width: 480px
    pointer-events: none
    @include for_breakpoint(mobile)
      max-width: 300px
      width: 70%
      left: -5px
      min-width: initial
      top: 100px
    // max-width: 450px
  .cats
    position: absolute
    left: 80px
    bottom: 30px
    z-index: 5
    .cat
      font-size: 24px
      margin: 2px 0
      padding: 5px
      position: relative
      &:after
        content: '▶︎'
        display: none
        position: absolute
        font-size: 1.6rem
        width: calc(50px + 100%)
        height: 100%
        transform: translate3D(-50%,-50%,0)
        left: -20%
        top: 58%
      &:before
        content: ''
        position: absolute
        width: calc(50px + 100%)
        height: 100%
        top: 0
        left: -50px
      &:hover
        cursor: pointer
        &:before
          border: solid 1px black
        &:after
          width: auto
          display: initial
      &.scene-selected:after
        content: '▶︎'
        position: absolute
        width: auto
        display: initial
        height: 100%
        transform: translate3D(-50%,-50%,0)
        left: -20%

    @include for_breakpoint(mobile)
      bottom: 0px
      left: 0px
      // padding-left: 20px
      width: 100vw
      // padding-bottom: 20px
      overflow: auto hidden
      display: flex
      flex-wrap: nowrap
      box-shadow: 5px -5px 30px -1px rgba(black,0.4)
      // .cats
      position: fixed
      .cat
        font-size: 1.1rem
        padding: 5px 15px
        // margin-bottom: 10px
        // margin-right: 3px
        border-right: solid 1px #333
        background-color: #fff
        display: block
        text-align: center
        min-width: 6.5rem
        // padding-left: 30px
        // left: -25px
        box-shadow: 5px -5px 30px -1px rgba(black,0.4)

        &:after
          left: -10%
          font-size: 1rem
          display: none
        &:before
          display: none
          // position: relative
        &.scene-selected:after
          left: -10%
          display: none
          // position: relative
        &.scene-selected
          background-color: black
          color: white
@include for_breakpoint(mobile)
  .home
    .side-scene
      display: none

@media screen and (max-width: 1024px)
  .home
    .side-scene-wrapper
      display: none

@keyframes rotattte
  0%
    transform: rotate(0deg) translate3D(-50%, -50%, 0)
  100%
    transform: rotate(360deg) translate3D(-50%, -50%, 0)
</style>
